import { Injectable } from '@angular/core';
import PouchDB from 'pouchdb';
import pouchdbDebug from 'pouchdb-debug';
import PouchDBFind from 'pouchdb-find';

@Injectable()
export class DbProvider {

  db: any;

  constructor() {
    PouchDB.plugin(pouchdbDebug);
    PouchDB.plugin(PouchDBFind);

    this.db = new PouchDB('chatData', {auto_compaction: true});
    // debugger;
    // PouchDB.debug.enable('pouchdb:find');
  }

  put(data: any, id= null) {
    if (id) {
      data._id = id;
    }
    return this.db.put(data);
  }

  findChatData(myId, chatPeopleId) {

      return this.db.createIndex({
        index: {fields: ['time', '$or']},
        name: 'timeor-index-design-doc',
        ddoc: 'timeor-index-design-doc',
        type: 'json'
      }).then(() => {
        return this.db.find({
          selector: {
            time: {$gt: null},
            $or: [
              {$and: [{userId: {$eq: myId}}, {toUserId : {$eq: chatPeopleId}}]},
              {$and: [{userId: {$eq: chatPeopleId}}, {toUserId : {$eq: myId}}]}
            ]
          },
          sort: ['time']
        });
      });
  }

}
